// extracted by mini-css-extract-plugin
export default {"smallFont":"KZE97mm2iKoPhdRCnDpg"};